import { render, staticRenderFns } from "./Label.vue?vue&type=template&id=421ee3b3&scoped=true"
var script = {}
import style0 from "./Label.vue?vue&type=style&index=0&id=421ee3b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421ee3b3",
  null
  
)

export default component.exports